// Hook odpowiedzialny za walidację koszyka

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  stepSymbol?: string;
}

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

const postVerifyCheckoutStep = (cartId: number, data: IRequest): Promise<IResponse> =>
  axios.post(`/carts/${cartId}/verify-checkout-step`, data);

export const usePostVerifyCheckoutStep = (
  cartId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postVerifyCheckoutStep(cartId, data), options);
